import {
  ContentWrapper,
  MainContentWrapper,
  ProductOverview,
  StyledWidgetSkeletonWrapper,
  WidgetLoadingWrapper,
} from './styled'
import { TotalExposure } from './component/total-exposure'
import CoverLoading from './component/product-cover/loading'
import Skeleton from 'react-loading-skeleton'
import React from 'react'
import type { ProductMetadata } from 'indices-list'
import {
  StyledText,
  SwitchContentContainer,
  SwitchElements,
  SwitchItem,
  SwitcherContainer,
} from './component/switch-sections/styled'

import { PerformanceLoading } from './component/switch-sections/performance/performance-content-loading'
import { ProductPreviewSwitchMenu } from './storage/interface'
import { useWindowSize } from 'hooks'

const ProductLoading: React.FC<{ product: ProductMetadata }> = ({ product }): JSX.Element => {
  const isApyShown = product.symbol !== 'artxai' && product.symbol !== 'jmx'
  const { isTablet } = useWindowSize()
  return (
    <>
      <ProductOverview>
        <CoverLoading symbol={product.symbol} />
        <WidgetLoadingWrapper isSmaller={isApyShown && isTablet}>
          <StyledWidgetSkeletonWrapper>
            <Skeleton height={isApyShown && isTablet ? 340 : 360} borderRadius="1.5rem" />
          </StyledWidgetSkeletonWrapper>
        </WidgetLoadingWrapper>
      </ProductOverview>
      <MainContentWrapper>
        <ContentWrapper>
          <SwitchContentContainer>
            <SwitcherContainer>
              <SwitchElements id="tour-performance">
                {ProductPreviewSwitchMenu.map((el) => (
                  <SwitchItem key={el}>
                    <StyledText active={false}>{el}</StyledText>
                  </SwitchItem>
                ))}
              </SwitchElements>
            </SwitcherContainer>
          </SwitchContentContainer>
          <PerformanceLoading />
          <TotalExposure product={product} />
        </ContentWrapper>
      </MainContentWrapper>
    </>
  )
}

export default ProductLoading
